import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {SimplePresentation, SimplePresentationRunner} from "../../../core/winpresentation/SimplePresentationRunner";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {BenjiKIVOverlayScatterRunner} from "../../presentationrunners/scatter/BenjiKIVOverlayScatterRunner";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVFreeSpinSpinRunner} from "../../presentationrunners/freespin/BenjiKIVFreeSpinSpinRunner";

/**
 * Created by Jerker Nord on 2022-12-12.
 */

export class BenjiKIVFreeSpinBetPresentation implements FlowStatePresentation {

    private _presentations:SimplePresentation[];
    private _flowStateController:FlowStateController;

    constructor() {
        this._presentations = [
            new BenjiKIVFreeSpinSpinRunner(),
            BenjiKIV.freeSpinOverlayRunner = new BenjiKIVOverlayScatterRunner()
        ]
    }

    public start(flowStateController:FlowStateController) {
        this._flowStateController = flowStateController;
        SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?:Function) => flowStateController.setSkipCallback(callback));
    }

    public complete() {
        this._flowStateController.finish();
    }
}